import React from 'react';

import CampaignActions from './components/CampaignActions';
import { CampaignType } from 'src/actions/campaigns/campaignsResource';
import EmptyState from 'src/presentation/components/pages/proactiveCommunications/components/shared/EmptyState';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import ProactiveCommunication from 'src/presentation/components/pages/proactiveCommunications/components/ProactiveCommunications';

const ProactiveEmail = ({ root }) => {
  const description = (
    <span>
      Proactively reach out to your customers through automated emails. Visit our{' '}
      <ExternalLink
        data-aid="set-up-proactive-email-help-link"
        label="Help Docs"
        to="https://help.gladly.com/docs/what-is-proactive-email"
      />{' '}
      to learn more about email Campaigns.
    </span>
  );

  const actions = <CampaignActions root={root} />;
  const emptyStateRender = <EmptyState title="Create your first Proactive Email Campaign" actionsRender={actions} />;

  return (
    <ProactiveCommunication
      actionsRender={actions}
      campaignType={CampaignType.EMAIL}
      description={description}
      header="Proactive Email"
      root={root}
      emptyStateRender={emptyStateRender}
    />
  );
};

export default ProactiveEmail;
